import { merge } from '@camelot/utils';

import { baseEnvironment } from './base-environment';

export const environment = merge()<typeof baseEnvironment>(baseEnvironment, {
  development: true,

  GTM: 'GTM-NXSXRTB5',
  SERVER_URL: 'https://api-dev.merlinsoftware.be',
  GRAPHQL_SERVER_CONFIG: {
    url: 'https://api-dev.merlinsoftware.be/merlin/',
  },

  DEBUG: true,
  LOCAL: false,

  PWAACTIVE: false,

  PLANNING: {
    enable: true,
  },
  FINANCIAL_CENTER: {
    enable: true,
  },
  CONTACT: {
    enable: true,
  },
  PROJECT: {
    enable: true,
  },
  ITEM: {
    enable: true,
  },
  DOMICILIATION: {
    enable: true,
  },
});
